/* unplugin-vue-components disabled */import script from "./contestTime.vue?vue&type=script&lang=ts&setup=true"
export * from "./contestTime.vue?vue&type=script&lang=ts&setup=true"

export default script